module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="account__user"><span>Account</span></div>\n<div class="account__interface js-account-interface ">\n    <div class="account-interface__header">\n        <span>'+
((__t=( name ))==null?'':__t)+
'</span>\n        <div class="account-interface__close js-interface-close"></div>\n    </div>\n    <ul class="account-interface__navigation">\n        <li class="js-user-settings">Settings</li>\n        <li class="js-user-logout">Logout</li>\n    </ul>\n</div>';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./js/modules/header/list/templates/account.html
// module id = 449
// module chunks = 0